import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SellerNoticeContent } from './SellerNotice';

export default function TransientSellerNotice({ content, className, plain = false, lines, persistent = false }: { content: string; className?: string; plain?: boolean; lines?: string[]; persistent?: boolean }) {
  const [visible, setVisible] = useState(Boolean(content.trim()));
  const [fading, setFading] = useState(false);
  useEffect(() => {
    setVisible(Boolean(content.trim()));
    setFading(false);
    if (!content.trim() || persistent) return;
    const fadeTimer = window.setTimeout(() => setFading(true), 3000);
    const hideTimer = window.setTimeout(() => setVisible(false), 5000);
    return () => { window.clearTimeout(fadeTimer); window.clearTimeout(hideTimer); };
  }, [content, persistent]);
  return visible && content.trim() ? <Notice className={className} role="note" aria-label="셀러 채팅" $fading={fading}>
    {plain ? <><strong>셀러 채팅</strong>{(lines ?? [content]).map((line, index) => <p key={index}>{line}</p>)}</> : <SellerNoticeContent content={content} />}
  </Notice> : null;
}

const Notice = styled.aside<{ $fading: boolean }>`
  opacity: ${({ $fading }) => $fading ? 0 : 1};
  transition: opacity 2s ease-out;
`;
